module.exports = __webpack_public_path__ + "2e9bb08c69442e2cefff384d0a2c5c50.ico";